exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".category-sliders-order-history {\n  width: 100%;\n  overflow: hidden;\n}\n.category-sliders-order-history .slick-track {\n    display: -ms-flexbox;\n    display: flex;\n}\n", ""]);

// exports
